module.exports = __webpack_public_path__ + "static/media/am_inquiry.331d61a4.md";


//////////////////
// WEBPACK FOOTER
// ./src/docs/am_inquiry.md
// module id = 1088
// module chunks = 0